module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('form', {
    staticClass: "scrollable container flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "flex form-control"
  }, [_c('u-input', {
    staticClass: "flex-1",
    attrs: {
      "placeholder": '请输入对方称呼' + (_vm.isEdit ? '只支持单人' : '，用逗号或空格间隔'),
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.name')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.name')))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "gift icon-contacts select-icon",
    on: {
      "click": function($event) {
        _vm.showContacts = true
      }
    }
  }), _vm._v(" "), (_vm.notInContactNames.length) ? _c('span', {
    staticClass: "gift icon-plus select-icon",
    on: {
      "click": _vm.autoAddContacts
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex form-control"
  }, [_c('u-input', {
    staticClass: "form-control flex-1",
    attrs: {
      "placeholder": "请选择礼钱分类，只支持单个分类",
      "tabindex": "2"
    },
    model: {
      value: (_vm.form.tag),
      callback: function($$v) {
        _vm.form.tag = $$v
      },
      expression: "form.tag"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.tag')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.tag')))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "gift icon-book select-icon",
    on: {
      "click": function($event) {
        _vm.showTags = true
      }
    }
  }), _vm._v(" "), (_vm.notInTags) ? _c('span', {
    staticClass: "gift icon-plus select-icon",
    on: {
      "click": _vm.autoAddTag
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "请输入礼钱数额",
      "tabindex": "3"
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.form.amount = _vm._n($$v)
      },
      expression: "form.amount"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.amount')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.amount')))]) : _vm._e()]), _vm._v(" "), _c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "请选择日期",
      "tabindex": "4"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.form.date = $$v
      },
      expression: "form.date"
    }
  }, [(_vm.submitted && _vm.validation.hasError('form.date')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('form.date')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('u-popup', {
    attrs: {
      "effect": "right",
      "full": ""
    },
    model: {
      value: (_vm.showContacts),
      callback: function($$v) {
        _vm.showContacts = $$v
      },
      expression: "showContacts"
    }
  }, [_c('contacts-manage', {
    attrs: {
      "selection": -1
    },
    on: {
      "back": function($event) {
        _vm.showContacts = false
      },
      "select": _vm.onContactsSelect
    }
  })], 1), _vm._v(" "), _c('u-popup', {
    attrs: {
      "effect": "right",
      "full": ""
    },
    model: {
      value: (_vm.showTags),
      callback: function($$v) {
        _vm.showTags = $$v
      },
      expression: "showTags"
    }
  }, [_c('tags-manage', {
    attrs: {
      "selection": 1
    },
    on: {
      "back": function($event) {
        _vm.showTags = false
      },
      "select": _vm.onTagsSelect
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af2da2f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditHistory.vue
// module id = 234
// module chunks = 3